"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Accordion = _interopRequireDefault(require("../Accordion"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Menu/index.js";
var defaultProps = {
  icon: 'bi bi-journal-text'
};
function Item(menu) {
  var name = menu.name,
    icon = menu.icon,
    label = menu.label,
    disabled = menu.disabled;
  var route = menu.route || '/collection/' + name;
  if (Array.isArray(route)) {
    return /*#__PURE__*/_react["default"].createElement(ItemChild, Object.assign({}, menu, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 14,
        columnNumber: 16
      }
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "nav-item",
    key: route,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    className: (0, _classNames["default"])("nav-link text-truncate", disabled ? 'disabled' : ''),
    to: route,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: icon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 17
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ms-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 17
    }
  }, label || name)));
}
Item.defaultProps = defaultProps;
function ItemChild(_ref) {
  var _this = this;
  var name = _ref.name,
    label = _ref.label,
    icon = _ref.icon,
    route = _ref.route,
    id = _ref.id;
  var key = id || name.replaceAll(' ', '');
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
    key: key,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("li", {
    className: "nav-item",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    eventKey: key,
    className: "nav-link font-size-sm text-truncate",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-inline",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: icon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 25
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ms-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 25
    }
  }, label || name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "float-end p-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-chevron-down",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 25
    }
  })))), /*#__PURE__*/_react["default"].createElement(_Accordion["default"].Collapse, {
    eventKey: key,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "navbar-nav ms-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 17
    }
  }, route.map(function (m, i) {
    return /*#__PURE__*/_react["default"].createElement(Item, Object.assign({}, m, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 32
      }
    }));
  }))));
}
function Menu(_ref2) {
  var _this2 = this;
  var menus = _ref2.menus;
  function renderDivider(index) {
    return /*#__PURE__*/_react["default"].createElement("hr", {
      key: index,
      className: "dropdown-divider bg-light",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58,
        columnNumber: 17
      }
    });
  }
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "navbar-nav",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 9
    }
  }, menus.map(function (menu, i) {
    if (!Object.keys(menu).length) return renderDivider(i);
    return /*#__PURE__*/_react["default"].createElement(Item, Object.assign({}, menu, {
      __self: _this2,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 28
      }
    }));
  }));
}
var _default = Menu;
exports["default"] = _default;